import userLogin from "./page/user/login.vue";
import authRedirect from "./page/user/authredirect.vue";
import indexLayout from "./page/layout/index.vue";
import dashboardIndex from "./page/dashboard/index.vue";
import casLogin from "./page/user/casLogin"

import managerLayout from "./page/manager/layout.vue";
import managerMemberList from "./page/manager/member-list.vue";
import managerFileList from "./page/manager/file-list.vue";
import managerSetting from "./page/manager/setting.vue";
import managerSmsTemplate from "./page/manager/sms_template.vue";
import exportList from "./page/manager/export-list.vue";

import customerList from "./page/customer/index.vue";
import customerDetail from "./page/customer/detail.vue";

import activityLayout from "./page/activity/layout.vue";
import activityTaskList from "./page/activity/task-list.vue";
import activityFailVerify from "./page/activity/fail-verify.vue";
import activityOrderVerify from "./page/activity/order-verify.vue";
import activityOrderApproved from "./page/activity/order-approved.vue";
import activityClueClear from "./page/activity/clue-clear.vue";

import frontCustomerList from "./page/front/index.vue";

import reportLayout from "./page/report/layout.vue";
import reportTask from "./page/report/task.vue";
import reportCustomer from "./page/report/customer.vue";
import reportSeries from "./page/report/series.vue";
import reportStoreCustomer from "./page/report/store-customer.vue";
import reportOnlineClue from "./page/report/online-clue.vue";
import reportSign from "./page/report/sign.vue";
import bigScreen from "./page/report/bigScreen.vue";
import newMediaClue from "./page/report/newMediaClue.vue"
import effectArrivalRate from "./page/report/effectArrivalRate.vue"
import effectArrivalClueCleaning from "./page/report/effectArrivalClueCleaning.vue"
import clueFollowDetails from "./page/report/clue-follow-details.vue"
import clueFollowStatistics from "./page/report/clue-follow-statistics.vue"

import orderLayout from "./page/order/layout.vue";
import orderCreated from "./page/order/created.vue";
import order from "./page/order/index.vue";
import blindOrder from "./page/order/blindIndex.vue";
import blindOrderDetail from "./page/order/blindOrderDetail.vue";
import smallOrder from "./page/order/smallOrderIndex.vue";
import smallOrderDetail from "./page/order/smallOrderDetail.vue";
import orderCancel from "./page/order/cancel.vue";
import waitingSubmit from "./page/order/waitingSubmit.vue";
import refundUnderReview from "./page/order/refundUnderReview.vue";
import pendingRefund from "./page/order/pendingRefund.vue";
import submitted from "./page/order/submitted.vue";
import approved from "./page/order/approved.vue";
import isCar from "./page/order/isCar.vue";
import rejected from "./page/order/rejected.vue";
import backOrder from "./page/order/backOrder.vue";
import Vue from "vue";
import Router from "vue-router";
import customerFlowList from './page/customer-flow/list.vue';
import customerFlowStatistics from './page/customer-flow/statistics.vue';

Vue.use(Router);

export const constantRouterMap = [
  {
    path: "/",
    redirect: "/dashboard/index"
  },
  {
    path: "/login",
    component: userLogin
  },
  {
    path: "/authRedirect",
    component: authRedirect
  },
  {
    path: "/casLogin",
    component: casLogin
  },
  {
    path: "/dashboard",
    component: indexLayout,
    children: [
      {
        path: "/dashboard/index",
        component: dashboardIndex
      }
    ]
  },
  {
    path: "/front",
    component: indexLayout,
    children: [
      {
        path: "/front/index",
        component: frontCustomerList
      }
    ]
  },
  {
    path: "/customer-flow",
    component: indexLayout,
    children: [
      {
        path: "/customer-flow/list",
        component: customerFlowList
      },
    ]
  },
  {
    path: "/customer-flowStatistics",
    component: indexLayout,
    children: [
      {
        path: "/customer-flowStatistics/list",
        component: customerFlowStatistics
      },
    ]
  },
  {
    path: "/manager",
    component: indexLayout,
    children: [
      {
        path: "/manager/members",
        component: managerLayout,
        children: [
          {
            path: "/manager/members",
            component: managerMemberList
          },
          {
            path: "/manager/files",
            component: managerFileList
          },
          {
            path: "/manager/setting",
            component: managerSetting
          },
          {
            path: "/manager/smstemplate",
            component: managerSmsTemplate
          },
          {
            path: "/manager/export-list",
            component: exportList
          }
        ]
      },
      {
        path: "/customer/list",
        component: customerList
      },
      {
        path: "/customer/detail/:customerId",
        component: customerDetail
      },
      {
        path: "/activity/tasks",
        component: activityLayout,
        children: [
          {
            path: "/activity/tasks",
            component: activityTaskList
          },
          {
            path: "/activity/fail-verify",
            component: activityFailVerify
          },
          {
            path: "/activity/order-verify",
            component: activityOrderVerify
          },
          {
            path: "/activity/clue-clear",
            component: activityClueClear
          },
          {
            path: "/activity/order-approved",
            component: activityOrderApproved
          }
        ]
      },
      {
        path: "/report/task",
        component: reportLayout,
        children: [
          {
            path: "/report/task",
            component: reportTask
          },
          {
            path: "/report/customer",
            component: reportCustomer
          },
          {
            path: "/report/series",
            component: reportSeries
          },
          {
            path: "/report/storeCustomer",
            component: reportStoreCustomer
          },
          {
            path: "/report/onlineClue",
            component: reportOnlineClue
          },
          {
            path: "/report/sign",
            component: reportSign
          },
          {
            path: "/report/bigScreen",
            component: bigScreen
          },
          {
            path: "/report/newMediaClue",
            component: newMediaClue
          },
          {
            path: "/report/effectArrivalRate",
            component: effectArrivalRate
          },
          {
            path: "/report/effectArrivalClueCleaning",
            component: effectArrivalClueCleaning
          },
          {
            path: "/report/clueFollowDetails",
            component: clueFollowDetails
          },
          {
            path: "/report/clueFollowStatistics",
            component: clueFollowStatistics
          },
        ]
      },
      {
        path: "/order/zzOrder",
        component: orderLayout,
        children: [
          {
            path: "/order/zzOrder",
            component: order
          },
          {
            path: "/order/blindOrder",
            component: blindOrder
          },
          {
            path: "/order/smallOrder",
            component: smallOrder
          },
        ]
      },
      {
        path: "/order/blindOrderDetail",
        component: blindOrderDetail
      },
      {
        path: "/order/smallOrderDetail",
        component: smallOrderDetail
      },
      {
        path: "/orderCreated",
        component: orderCreated
      },
      {
        path: "/orderCancel",
        component: orderCancel
      },
      {
        path: "/waitingSubmit",
        component: waitingSubmit
      },
      {
        path: "/refundUnderReview",
        component: refundUnderReview
      },
      {
        path: "/pendingRefund",
        component: pendingRefund
      },
      {
        path: "/submitted",
        component: submitted
      },
      {
        path: "/approved",
        component: approved
      },
      {
        path: "/isCar",
        component: isCar
      },
      {
        path: "/rejected",
        component: rejected
      },
      {
        path: "/backOrder",
        component: backOrder
      }
    ]
  }
];
export default new Router({
  // mode: "history",
  mode: "hash",
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
});
